import { Box, styled } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import { CarouselArrowIndex } from '../../fl-components/carousel';
import Image from '../../fl-components/Image';
import LightboxModal from '../../fl-components/LightboxModal';

const RootStyle = styled('div')(({ theme }) => ({
  '& .slick-slide': {
    float: theme.direction === 'rtl' ? 'right' : 'left',
    '&:focus': { outline: 'none' }
  }
}));

export default function ImageCarousel({ images }) {
  const [openLightbox, setOpenLightbox] = useState(false);

  const [selectedImage, setSelectedImage] = useState(0);

  const [currentIndex, setCurrentIndex] = useState(0);

  const slider1 = useRef(null);

  const settings1 = {
    dots: false,
    arrows: false,
    slidesToShow: 1,
    draggable: false,
    slidesToScroll: 1,
    adaptiveHeight: true,
    beforeChange: (current, next) => setCurrentIndex(next)
  };

  const handlePrevious = () => {
    slider1.current?.slickPrev();
  };

  const handleNext = () => {
    slider1.current?.slickNext();
  };

  const imagesLightbox = images.map((_image) => _image.url);

  const handleOpenLightbox = (url) => {
    const selectedImage = imagesLightbox.findIndex((index) => index === url);
    setOpenLightbox(true);
    setSelectedImage(selectedImage);
  };

  return (
    <RootStyle>
      <Box sx={{ zIndex: 0, borderRadius: 1, overflow: 'hidden', position: 'relative' }}>
        <Slider {...settings1} ref={slider1}>
          {images.map((img) => (
            <Image
              key={img.url}
              alt={img.name || 'large image'}
              src={img.url}
              ratio="4/3"
              onClick={() => handleOpenLightbox(img.url)}
              sx={{ cursor: 'zoom-in' }}
              imageStyle={{ objectPosition: '50% 16%' }}
            />
          ))}
        </Slider>
        <CarouselArrowIndex
          index={currentIndex}
          total={images.length}
          onNext={handleNext}
          onPrevious={handlePrevious}
        />
      </Box>

      <LightboxModal
        images={imagesLightbox}
        mainSrc={imagesLightbox[selectedImage]}
        photoIndex={selectedImage}
        setPhotoIndex={setSelectedImage}
        isOpen={openLightbox}
        onCloseRequest={() => setOpenLightbox(false)}
      />
    </RootStyle>
  );
}

ImageCarousel.propTypes = {
  images: PropTypes.array
};
